"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLazyImageSlots = exports.default = exports.LazyImage = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _SuspenseImage = _interopRequireDefault(require("../SuspenseImage"));
var _useIntersectionObserver = _interopRequireDefault(require("../useIntersectionObserver"));
var _lazyImageClasses = require("./lazyImageClasses");
var _jsxRuntime = require("react/jsx-runtime");
var getLazyImageSlots = function(_) {
    return {
        root: [
            'root'
        ],
        skeleton: [
            'skeleton'
        ],
        image: [
            'image'
        ]
    };
};
exports.getLazyImageSlots = getLazyImageSlots;
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = getLazyImageSlots(ownerState);
    var composedClasses = (0, _base.unstable_composeClasses)(slots, _lazyImageClasses.getLazyImageUtilityClass, classes);
    return _object_spread({}, classes, composedClasses);
};
var LazyImageRoot = (0, _material.styled)('span', {
    name: 'MuiOriLazyImage',
    slot: 'Root',
    overridesResolver: function(_, styles) {
        return [
            styles.root
        ];
    }
})(function(param) {
    var _param_ownerState = param.ownerState, width = _param_ownerState.width, height = _param_ownerState.height;
    return {
        display: 'inline-block',
        height: height,
        width: width
    };
});
var LazyImageSkeleton = (0, _material.styled)(_material.Skeleton, {
    name: 'MuiOriLazyImage',
    slot: 'Skeleton',
    overridesResolver: function(_, styles) {
        return [
            styles.skeleton
        ];
    }
})({
    display: 'inline-block',
    height: '100%',
    width: '100%'
});
var LazyImageImg = (0, _material.styled)('img', {
    name: 'MuiOriLazyImage',
    slot: 'Image',
    overridesResolver: function(_, styles) {
        return [
            styles.image
        ];
    }
})({
    display: 'inline-block',
    height: '100%',
    width: '100%'
});
var InnerSuspendedImage = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var loading = props.loading, didIntersect = props.didIntersect, classes = props.classes, src = props.src, srcSet = props.srcSet, imgProps = props.imgProps, SuspenseImageProps = props.SuspenseImageProps, errorFallback = props.errorFallback, alt = props.alt;
    var imageProps = {
        errorFallback: errorFallback,
        alt: alt
    };
    if (loading === 'eager' || didIntersect) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LazyImageImg, _object_spread(_object_spread_props(_object_spread({
            as: _SuspenseImage.default
        }, imageProps), {
            ref: ref,
            className: classes === null || classes === void 0 ? void 0 : classes.image,
            src: src,
            srcSet: srcSet
        }), imgProps, SuspenseImageProps));
    }
    // Do not mount suspended image
    return null;
});
var InnerLazyImage = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var loading = props.loading, didIntersect = props.didIntersect, errorFallback = props.errorFallback, classes = props.classes, _props_fallback = props.fallback, fallback = _props_fallback === void 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LazyImageSkeleton, {
        animation: "wave",
        className: classes === null || classes === void 0 ? void 0 : classes.skeleton,
        variant: "rectangular"
    }) : _props_fallback, src = props.src, srcSet = props.srcSet, imgProps = props.imgProps, alt = props.alt;
    var imageProps = {
        alt: alt
    };
    var _ref = _sliced_to_array((0, _react.useState)(loading === 'eager'), 2), isLoaded = _ref[0], setIsLoaded = _ref[1];
    var _ref1 = _sliced_to_array((0, _react.useState)(), 2), error = _ref1[0], setError = _ref1[1];
    (0, _react.useEffect)(function() {
        if (loading === 'eager' || loading === 'lazy' && !didIntersect) {
            return function() {};
        }
        var onLoad = function() {
            return setIsLoaded(true);
        };
        var onError = function(event) {
            return setError(event);
        };
        var image = new Image();
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        if (srcSet) {
            image.srcset = srcSet;
        }
        image.src = src;
        image.alt = alt !== null && alt !== void 0 ? alt : '';
        return function() {
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        loading,
        didIntersect,
        src,
        srcSet,
        alt
    ]);
    if (isLoaded) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LazyImageImg, _object_spread(_object_spread_props(_object_spread({}, imageProps), {
            ref: ref,
            src: src,
            srcSet: srcSet,
            className: classes === null || classes === void 0 ? void 0 : classes.image
        }), imgProps));
    }
    if (error !== undefined) {
        return errorFallback;
    }
    return fallback;
});
var LazyImage = exports.LazyImage = /*#__PURE__*/ (0, _react.forwardRef)(function(inProps, inRef) {
    var props = (0, _material.useThemeProps)({
        props: inProps,
        name: 'MuiOriLazyImage'
    });
    var wrapperRef = (0, _react.useRef)();
    var ref = (0, _material.useForkRef)(inRef, wrapperRef);
    var className = props.className, sx = props.sx, component = props.component, _props_loading = props.loading, loading = _props_loading === void 0 ? 'lazy' : _props_loading, _props_shouldThrowError = props.shouldThrowError, shouldThrowError = _props_shouldThrowError === void 0 ? false : _props_shouldThrowError, _props_enableSuspense = props.enableSuspense, enableSuspense = _props_enableSuspense === void 0 ? false : _props_enableSuspense, _props_errorFallback = props.errorFallback, errorFallback = _props_errorFallback === void 0 ? null : _props_errorFallback, fallback = props.fallback, imgRef = props.imgRef, width = props.width, height = props.height, src = props.src, srcSet = props.srcSet, SuspenseImageProps = props.SuspenseImageProps, imgProps = props.imgProps, otherProps = _object_without_properties(props, [
        "className",
        "sx",
        "component",
        "loading",
        "shouldThrowError",
        "enableSuspense",
        "errorFallback",
        "fallback",
        "imgRef",
        "width",
        "height",
        "src",
        "srcSet",
        "SuspenseImageProps",
        "imgProps"
    ]);
    var didIntersect = (0, _useIntersectionObserver.default)({
        ref: wrapperRef,
        disabled: loading === 'eager',
        unmountAfterIntersection: true
    }).didIntersect;
    var ownerState = _object_spread_props(_object_spread({}, props), {
        SuspenseImageProps: SuspenseImageProps,
        imgProps: imgProps,
        src: src,
        srcSet: srcSet,
        width: width,
        height: height,
        loading: loading,
        shouldThrowError: shouldThrowError,
        errorFallback: errorFallback,
        didIntersect: didIntersect
    });
    var classes = useUtilityClasses(ownerState);
    var InnerComponent = enableSuspense ? InnerSuspendedImage : InnerLazyImage;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LazyImageRoot, _object_spread_props(_object_spread({
        ref: ref,
        ownerState: ownerState,
        sx: sx,
        as: component,
        className: (0, _clsx.default)(classes.root, className)
    }, otherProps), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InnerComponent, _object_spread_props(_object_spread({}, ownerState), {
            ref: imgRef,
            classes: classes
        }))
    }));
});
var _default = exports.default = LazyImage; //# sourceMappingURL=LazyImage.js.map
